/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_NameInputs */

const en_form_name = /** @type {(inputs: Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const he_form_name = /** @type {(inputs: Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שם`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Form_NameInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_name = /** @type {((inputs?: Form_NameInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_NameInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_name(inputs)
	return he_form_name(inputs)
});